import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";


import CateringProviderCard from "./carthelpercomponents/CateringProviderCard";
import PriestCard from "./carthelpercomponents/PriestCard";
import TentProviderCard from "./carthelpercomponents/TentProviderCard";

import config from "../../config";

import {
  clearCheckoutRequest,
  fetchCheckoutPage,
  applyCoupon,
  removeCoupon,
} from "../../store/checkoutSlice";

import {
  payment_checkout,
  payment_verification,
} from "../../Apiservices/Auth/payments/orderevent";

import "./checkoutPage.css";

const CheckoutPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [payLoading, setPayLoading] = useState(false);

  // ✅ NEW: local state for coupon input
  const [couponInput, setCouponInput] = useState("");

  const { eventId } = location.state || {};

  // -------------------------------
  // REDIRECT IF NO EVENT
  // -------------------------------
  useEffect(() => {
    if (!eventId) {
      navigate("/dashboard");
    }
  }, [eventId, navigate]);

  // -------------------------------
  // REDUX STATE
  // -------------------------------
  const checkoutState = useSelector((state) => state.checkout) || {};

  const {
    checkOutPageResponse,
    loading,
    refreshLoading,
    checkOutRequest,
  } = checkoutState;

  // -------------------------------
  // INIT
  // -------------------------------
  useEffect(() => {
    if (!eventId) return;

    dispatch(clearCheckoutRequest(eventId));
    dispatch(fetchCheckoutPage());
  }, [eventId, dispatch]);

  // -------------------------------
  // SYNC COUPON (optional)
  // -------------------------------
  useEffect(() => {
    if (checkOutRequest?.coupon) {
      setCouponInput(checkOutRequest.coupon);
    }
  }, [checkOutRequest]);


  useEffect(() => {
    if (!checkOutRequest?.event_id) return;

    dispatch(fetchCheckoutPage());

  }, [
    checkOutRequest?.priest,
    checkOutRequest?.tent,
    checkOutRequest?.catering,
    checkOutRequest?.tent_pct,
    checkOutRequest?.priest_pct,
    checkOutRequest?.catering_pct,
  ]);

  // -------------------------------
  // COUPON
  // -------------------------------
  const handleApplyCoupon = () => {
    dispatch(applyCoupon(couponInput));
    dispatch(fetchCheckoutPage());
  };

  const handleRemoveCoupon = () => {
    dispatch(removeCoupon());
    setCouponInput("");
    dispatch(fetchCheckoutPage());
  };

  // -------------------------------
  // PAYMENT PAYLOAD
  // -------------------------------
  const buildPaymentPayload = () => {
    if (!checkOutPageResponse) return {};

    const payload = {
      event_id: eventId,
      coupon_code: checkOutRequest?.coupon || "",
      amount: {},
    };

    const res = checkOutPageResponse;

    if (res.priestItems?.length) {
      payload.amount.priest = res.priestItems
        .filter((p) => p.paymentSummary?.payable_now > 0)
        .map((p) => ({
          priestId: p.priest?.id,
          amount: p.paymentSummary?.payable_now,
        }));
    }

    if (res.tent_providers?.length) {
      payload.amount.tentRentals = res.tent_providers
        .filter((t) => t.paymentSummary?.payable_now > 0)
        .map((t) => ({
          tentRentalId: t.provider_id,
          amount: t.paymentSummary?.payable_now,
        }));
    }

    if (res.catering_providers?.length) {
      payload.amount.catering = res.catering_providers
        .filter((c) => c.paymentSummary?.payable_now > 0)
        .map((c) => ({
          cateringId: c.provider_id,
          amount: c.paymentSummary?.payable_now,
        }));
    }

    return payload;
  };

  // -------------------------------
  // PAYMENT
  // -------------------------------
  const handlePayment = async () => {
    try {
      setPayLoading(true);

      const payload = buildPaymentPayload();

      const checkoutData = await payment_checkout(eventId, payload);

      const options = {
        key: checkoutData.key_id,
        amount: checkoutData.order.amount,
        currency: "INR",
        order_id: checkoutData.order.id,
        name: "Event Booking",
        description: checkOutPageResponse?.eventTitle || "Payment",
        handler: async function (response) {
          await payment_verification(eventId, {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          });

          alert("Payment Successful 🎉");
          navigate("/dashboard");
        },
        prefill: {
          name: "User",
          email: "test@mail.com",
          contact: "9999999999",
        },
        theme: { color: "#0D47A1" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error(err);
      alert("Payment failed");
    } finally {
      setPayLoading(false);
    }
  };

  // -------------------------------
  // UI STATES
  // -------------------------------
  if (loading) return <div className="loader">Loading checkout...</div>;

  if (!checkOutPageResponse)
    return <div>No checkout data found</div>;

  const response = checkOutPageResponse;

  // -------------------------------
  // UI
  // -------------------------------
  return (
    <div className="checkout-container">
      {/* HEADER */}
      <div className="checkout-header">
        <button onClick={() => navigate(-1)}>← Back</button>
        <h2>Checkout</h2>
      </div>

      {/* EVENT */}
      <div className="event-card">
        <img
          className="event-image"
          src={
            response?.event_image_id
              ? `${config.API_BASE_URL}/gallery/download/${response.event_image_id}?isDownload=false`
              : "/assets/images/thurent-favicon.svg"
          }
          alt={response?.event_title || "event"}
          onError={(e) => {
            e.target.src = "/assets/images/thurent-favicon.svg";
          }}
        />

        <div>
          <h4>{response.event_title}</h4>
          <p>{response.venue}</p>
          <p>
            {(() => {
              const dt = new Date(response.event_start_date);

              if (isNaN(dt)) return "Invalid date";

              const day = dt.toLocaleDateString("en-IN", { weekday: "short" });
              const date = dt.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
              const time = dt.toLocaleTimeString("en-IN", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true
              });

              return `${day}, ${date} | ${time}`;
            })()}
          </p>
        </div>
      </div>




      {response?.catering_providers?.length > 0 && (

        <div>
          <h3>Catering Services</h3>

          {response?.catering_providers.map((provider) => (
            <CateringProviderCard
              key={provider.provider_id}
              provider={provider}
              eventId={eventId}
              isCheckout={true}
            />
          ))}
        </div>
      )}

      {response?.priestItems?.length > 0 && (

        <div>
          <h3>Priest Services</h3>

          {response?.priestItems.map((provider) => (
            <PriestCard
              key={provider.priest?.id}
              item={provider}
              eventId={eventId}
              isCheckout={true}
              isOrders={false}
            />
          ))}
        </div>
      )}

      {response?.tent_providers?.length > 0 && (

        <div>
          <h3>Tent House Rentals</h3>

          {response?.tent_providers?.map((p) => (
            <TentProviderCard
              key={p.provider_id}
              provider={p}
              eventId={eventId}
              isCheckout={true}
              isOrders={false}
            />
          ))}
        </div>
      )}



      {/* COUPON */}
      <div className="coupon-box">
        <div className="row-between" >
          <input

            value={couponInput}
            onChange={(e) => setCouponInput(e.target.value)}
            placeholder="Enter coupon"
          />

          <button onClick={handleApplyCoupon}>Apply</button>
        </div>


        {response.coupon && (
          <div>
            {response.coupon.valid
              ? "Coupon Applied"
              : response.coupon.message}
            <button onClick={handleRemoveCoupon}>Remove</button>
          </div>
        )}
      </div>

      {/* SUMMARY */}

      <div className="summary-box">
        <h3>Payment Summary</h3>
        <div className="row-between">
          <span className="row-title">Total</span>
          <span className="row-value">₹{response.total}</span>
        </div>
        <div className="row-between">
          <span className="row-title">Paid</span>
          <span className="row-value">₹{response.paid}</span>
        </div>
        <div className="row-between">
          <span className="row-title">Balance</span>
          <span className="row-value">₹{response.balanceToPay}</span>
        </div>
      </div>

      <div className="summary-box">
        <h3>Payment Breakdown</h3>

        {response?.logs.map((log) => <div className="row-between">
          <span className="row-title">{log.title}</span>
          <span className="row-value">{log.body}</span>
        </div>)}
      </div>


      {/* PAYMENT */}
      <div className="bottom-bar">
        <h3>₹{response.balanceToPay}</h3>

        <button
          disabled={(response.balanceToPay || 0) <= 0 || payLoading}
          onClick={handlePayment}
        >
          {payLoading
            ? "Processing..."
            : `Pay ₹${response.totalPayableNow}`}
        </button>
      </div>

      {refreshLoading && <div className="overlay-loader">Updating...</div>}
    </div>
  );
};

export default CheckoutPage;